import { Banner, Stack, Typography } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { TextMessagingConfiguration } from '@mews-commander/data-access';
import { AfterStartFormContainer } from './AfterStartFormContainer';

interface AfterStartTabProps {
    enterpriseId: string;
    configuration: TextMessagingConfiguration;
}

export const AfterStartTab = ({ enterpriseId, configuration }: AfterStartTabProps) => (
    <Stack spacing="500" vertical>
        <Stack vertical spacing="200">
            <Typography textStyle="titleSmall" as="p">
                <LocalizedText textKey={TextKey.AfterStartTabGeneralInfoText} />
            </Typography>
            <Banner
                secondaryText={<LocalizedText textKey={TextKey.AfterStartTabGeneralInfoBannerText} />}
                variant="info"
            />
        </Stack>
        <AfterStartFormContainer enterpriseId={enterpriseId} configuration={configuration} />
    </Stack>
);
